import {hitGoogleTagManager} from "./init_google_tag_manager";

export const gtmOfferOpinionsButtonClick = (label: string) => {
    hitGoogleTagManager({
        event: "offer_rate",
        event_category: "cta",
        event_action: "click",
        event_label: label
    });
};

export const gtmOfferOpinionsFormOptionClick = (label: string) => {
    hitGoogleTagManager({
        event: "offer_rate",
        event_category: "options",
        event_action: "click",
        event_label: label
    });
};
import {hitGoogleTagManager} from "./init_google_tag_manager";

export const gtmOfferOpinionsButtonClick = (label: string) => {
    hitGoogleTagManager({
        event: "offer_rate",
        event_category: "cta",
        event_action: "click",
        event_label: label
    });
};

export const gtmOfferOpinionsFormOptionClick = (label: string) => {
    hitGoogleTagManager({
        event: "offer_rate",
        event_category: "options",
        event_action: "click",
        event_label: label
    });
};
